import { i18n } from '@/locale/i18n'
import { syncToLocal } from '../mixins'

export default {
  namespaced: true,

  actions: {
    beforeCreate (context, record) {
      let slab = context.getters['slabs/find'](record.slab_id)

      // if seems that at initial create (load data) the slab is NULL (maybe it's created afterwards) but this is lucky at this point
      // TODO: maybe we should add the maximum number of loads here too
      if (slab && slab.calculation_busy && !context.rootState.allowChanges) {
        uikit.modal.alert(i18n.t('locked_record_busy'))

        return false
      } else if (slab && slab.calculation_pdf && !context.rootState.allowChanges) {
        uikit.modal.confirm(i18n.t('locked_record_pdf'), {
          labels: {
            ok: i18n.t('buttons.cancel'),
            cancel: i18n.t('buttons.unlock')
          }
        }).then(function () {
          // old ok (default selected) = cancel, do nothing
        }, function () {
          // cancel = Unlock & recall the requested add
          context.dispatch('slabs/unlock', record.slab_id).then(() => context.dispatch('openings/insert', {data: record}))
        })

        return false
      }
    },

    afterCreate (context, record) {
      if (!context.rootState.allowChanges) {
        context.dispatch('slabs/update', {
          where: record.slab_id,
          data: {
            savedOnServer: false
          }
        })
      }

      syncToLocal(context)
    },

    beforeUpdate (context, record) {
      let slab = context.getters['slabs/find'](record.slab_id)

      if (slab && slab.calculation_busy && !context.rootState.allowChanges) {
        uikit.modal.alert(i18n.t('locked_record_busy'))

        return false
      } else if (slab && slab.calculation_pdf && !context.rootState.allowChanges) {
        uikit.modal.confirm(i18n.t('locked_record_pdf'), {
          labels: {
            ok: i18n.t('buttons.cancel'),
            cancel: i18n.t('buttons.unlock')
          }
        }).then(function () {
          // old ok (default selected) = cancel, do nothing
        }, function () {
          // cancel = Unlock
          context.commit('slabs/unlock', record.slab_id)
        })

        return false
      } else {
        return record
      }
    },

    afterUpdate (context, record) {
      if (!context.rootState.allowChanges) {
        context.dispatch('slabs/update', {
          where: record.slab_id,
          data: {
            savedOnServer: false
          }
        })
      }

      syncToLocal(context)
    },

    beforeDelete (context, record) {
      let slab = context.getters['slabs/find'](record.slab_id)

      if (slab && slab.calculation_busy && !context.rootState.allowChanges) {
        uikit.modal.alert(i18n.t('locked_record_busy'))

        return false
      } else if (slab && slab.calculation_pdf && !context.rootState.allowChanges) {
        uikit.modal.confirm(i18n.t('locked_record_pdf'), {
          labels: {
            ok: i18n.t('buttons.cancel'),
            cancel: i18n.t('buttons.unlock')
          }
        }).then(function () {
          // old ok (default selected) = cancel, do nothing
        }, function () {
          // cancel = Unlock & recall the requested delete
          context.dispatch('slabs/unlock', record.slab_id).then(() => context.dispatch('openings/delete', `${slab.id}_${record.id}`))
        })

        return false
      }
    },

    afterDelete (context, record) {
      if (!context.rootState.allowChanges) {
        context.dispatch('slabs/update', {
          where: record.slab_id,
          data: {
            savedOnServer: false
          }
        })
      }

      syncToLocal(context)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/openings.js